









import { Component, Vue, Model, Emit } from 'vue-property-decorator';
import SearchPaginationTable from '@/components/search-pagination-table.vue';
import Dialog from '@/components/dialog.vue';
import AddSub from './add-sub.vue';
import EditSub from './edit-sub.vue';
import EditWhite from './edit-white.vue';
import moment from 'moment';
import { post, get } from '@/unite/api';
@Component({
  components: { SearchPaginationTable, Dialog, AddSub, EditSub, EditWhite }
})
export default class RunningwaterDetails extends Vue {
  mounted() {}
  created() {
    // console.log(this.api.get('/admin/apply/list', this.pageData.info))
  }
  optionTitle: string = '';
  visible: boolean = false;
  visibleAdd: boolean = false;
  visibleEdit: boolean = false;
  visibleWhite: boolean = false;
  sendData: any;
  modifyForm: any;
  rules: any[] = [];
  pageData: any = {
    url: '/back/v1/sub/list',
    isSearch: false, // 是否需要搜索框
    isPagination: true, // 是否后端分页
    isBtn: true, // 是否需要头部操作按钮
    info: {
      page_num: 10,
      page_index: 1
    }, // 传后端数据
    searchData: [
      {
        type: 'input', // text框
        model: 'name', // 字段
        tip: '部门',
        placeholder: '请输入要查询的部门'
      }
    ],
    btnData: [
      {
        name: '刷新列表',
        methods: 'refesh',
        type: 'success',
        loading: false
      },
      {
        name: '添加订阅',
        methods: 'add',
        type: 'success',
        loading: false
      },
      {
        name: '导出部门',
        methods: 'downAll',
        type: 'downAll',
        loading: false
      }
    ],
    tableData: {
      stripe: true,
      border: true,
      expandShow: false,
      optionShow: true,
      header: [
        // {
        //   prop: 'id',
        //   label: 'ID',
        //   width: 80
        // },
        {
          prop: 'name',
          label: '名称'
        },
        {
          prop: 'enable',
          _prop: 'disable',
          label: '是否启用',
          width: '110',
          type: 'switch',
          status: {
            true: false,
            false: true
          }
        },
        {
          prop: 'addr',
          label: '地址'
        },
        {
          prop: 'mode',
          // _prop: 'mode',
          label: '模式'
          // status: {
          //   1: 'WebSocket',
          //   2: 'HTTP',
          //   3: 'RPC'
          // }
        },
        {
          prop: 'code',
          label: 'code'
        },
        {
          prop: 'pv',
          label: 'pv',
          type: 'pv'
        },
        {
          prop: 'sv',
          label: 'sv',
          type: 'sv'
        },
        {
          prop: 'owner',
          label: '管理者',
          width: 110
        }
      ],
      expand: [],
      optionWidth: 220,
      option: [
        {
          name: '修改',
          methods: 'modify',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '重置token',
          methods: 'reset',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '删除',
          methods: 'delete',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        },
        {
          name: '白名单管理',
          methods: 'white',
          type: 'text',
          role: function(row: any) {
            return 1;
          }
        }
      ]
    } // table
  };
  dialogAddData: any = {
    modifyForm: {
      url: '/back/v1/dpt/create',
      width: '35%',
      form: {
        name: ''
      },
      showData: [],
      formLabelWidth: '100px',
      data: [
        {
          type: 'input',
          model: 'name',
          name: '部门名称'
        }
      ],
      select: {
        role: []
      }
    },
    rules: {
      name: [
        {
          required: true,
          message: '请输入部门名称',
          trigger: 'blur'
        }
      ]
    }
  };
  private handleClick(methods: string, row: any) {
    this.sendData = row;
    if (methods === 'modify') {
      this.visibleEdit = true;
    } else if (methods === 'enable') {
      this.publicApi(
        `/back/v1/sub/enable?id=${row.id}&enable=${!row.enable}`,
        `是否确认${!row.enable ? '禁用' : '开启'}${row.name}`,
        {}
      );
    } else if (methods === 'delete') {
      this.publicApi(
        `/back/v1/sub/delete?id=${row.id}`,
        `是否确认删除${row.name}`,
        {}
      );
    } else if (methods === 'reset') {
      this.publicApi(
        `/back/v1/sub/reset?id=${row.id}`,
        `是否确认重置${row.name}Token`,
        {}
      );
    } else if (methods === 'white') {
      this.visibleWhite = true;
    }
  }
  private btnClick(methods: string) {
    if (methods === 'add') {
      this.visibleAdd = true;
    }
  }
  // 刷新列表
  refesh(bool: boolean) {
    if (bool) {
      // @ts-ignore
      this.$refs.table.getData();
    }
    this.visible = false;
    this.visibleAdd = false;
    this.visibleEdit = false;
    this.visibleWhite = false;
    this.visibleWhite = false;
  }
  // 公共方法
  publicApi(url: string, msg: string, Infodata: any) {
    this.$confirm(msg, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        get(url, Infodata)
          .then(d => {
            // @ts-ignore
            this.$refs.table.getData();
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          })
          .catch(e => {
            // @ts-ignore
            this.$refs.table.getData();
          });
      })
      .catch(() => {
        // @ts-ignore
        this.$refs.table.getData();
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
  }
}
